import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import PeopleIcon from '@mui/icons-material/People';
import ScheduleIcon from '@mui/icons-material/Schedule';
import { Routes } from '../../../routes/RouteConstants';

/**
 * The admin menu, in the order it is shown (DECISIONS.md D32, phase 2). `end` marks the calendar:
 * it is the index of /dashboard, so it must only light up on /dashboard itself, not on every page
 * under it. `tenantFlag` names a tenant field that must be true for the entry to show: coupons are
 * herevr's only, for now. `adminOnly` entries are the tenant's, not a provider's: a provider who is
 * no admin sees the calendar and the inactive periods only (docs/MULTI_PROVIDER.md, flow 3).
 */
export const ADMIN_SECTIONS = [
  { to: Routes.DASHBOARD, end: true, label: 'Naptár', Icon: CalendarMonthIcon, testId: 'admin-nav-calendar' },
  { to: Routes.DASHBOARD_BLOCK_PERIOD, label: 'Inaktív időszak', Icon: EventBusyIcon, testId: 'admin-nav-block-period' },
  { to: Routes.DASHBOARD_OPENING_HOURS, label: 'Nyitvatartás és szünetek', Icon: ScheduleIcon, testId: 'admin-nav-opening-hours', adminOnly: true },
  { to: Routes.DASHBOARD_GUESTS, label: 'Vendégeim', Icon: PeopleIcon, testId: 'admin-nav-guests', adminOnly: true },
  { to: Routes.DASHBOARD_COUPONS, label: 'Kuponok', Icon: LocalOfferIcon, testId: 'admin-nav-coupons', tenantFlag: 'isCouponEnabled', adminOnly: true },
];

/** Shared by the aside and the drawer, so both open to the same width. */
export const SIDEBAR_WIDTH = 240;

/** The sticky top bar's height; the aside sits below it. */
export const TOPBAR_HEIGHT = 64;

/**
 * The aside stays put only from `xl` (1536px) up. Below that it would take its 240px from the
 * calendar, the widest thing in the app, so it opens as a drawer instead (DECISIONS.md D32).
 */
export const PERMANENT_SIDEBAR_BREAKPOINT = 'xl';

/** A neutral ground for the admin pages, whatever the tenant's own theme. */
export const ADMIN_BACKGROUND = '#f5f6f8';
